// @ts-nocheck
import { sideMenuLinkStyles, sideMenuWrapperStyles } from "@store/Themes/common/mixins/sidemenu";
import { StyledButton } from "@insite/mobius/Clickable";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { linkStyles } from "@store/Themes/common/mixins/link";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { focusUpdateStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

const menu: Styleguide["menu"] = {
    defaultProps: {
        menuItemClickableProps: {
            css: css`
                min-height: 0;
            `,
        },
        menuItemTypographyProps: {
            css: css`
                padding: 0 !important;
            `,
        },
        // Store Custom Code - >
        cssOverrides: {
            wrapper: css`
                ${sideMenuWrapperStyles()}
            `,
            menuItem: css`
                ${sideMenuLinkStyles()}
            `,
        },
        // <-- Majestic Custom Code
    },
};

export default menu;
